export default "__VITE_ASSET__CyK5MGZd__"